<template>
  <div class="wrapper contact-page">
    <div class="page-header page-header-small">
      <parallax
          class="page-header-image"
          :style="{ backgroundImage: `url(${bgImage})` }"
      />
    </div>
    <div class="main">
      <div class="contact-content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 ml-auto mr-auto">
              <h2 class="title">
                Schreiben Sie uns eine Nachricht
              </h2>
              <p class="description">
                und wir beantworten Ihre Anfrage innerhalb von 24 Stunden.
                <br><br>
              </p>
              <form
                  id="contact-form"
                  role="form"
                  method="post"
                  @submit.prevent="onSubmit"
                  v-if="!formSubmitted"
              >
                <label>Ihr Vorname</label>
                <fg-input
                    v-model="form.firstName"
                    placeholder="Ihr Vorname..."
                    addon-left-icon="now-ui-icons users_circle-08"
                />
                <div v-if="errors.firstName" style="color:red; font-size:0.9em;">
                  {{ errors.firstName }}
                </div>
                <label>Ihr Nachname</label>
                <fg-input
                    v-model="form.lastName"
                    placeholder="Ihr Nachname..."
                    addon-left-icon="now-ui-icons users_circle-08"
                />
                <div v-if="errors.lastName" style="color:red; font-size:0.9em;">
                  {{ errors.lastName }}
                </div>
                <label>Ihre Mailadresse</label>
                <fg-input
                    v-model="form.email"
                    placeholder="Ihre Mailadresse..."
                    addon-left-icon="now-ui-icons users_circle-08"
                />
                <div v-if="errors.emailPhone" style="color:red; font-size:0.9em;">
                  {{ errors.emailPhone }}
                </div>
                <label>Ihre Telefonnummer (falls Sie lieber zurückgerufen werden wollen)</label>
                <fg-input
                    v-model="form.phone"
                    placeholder="Ihre Telefonnummer (optional)..."
                    addon-left-icon="now-ui-icons tech_mobile"
                />
                <div v-if="errors.emailPhone" style="color:red; font-size:0.9em;">
                  {{ errors.emailPhone }}
                </div>
                <div class="form-group">
                  <label>Ihr Anliegen</label>
                  <textarea
                      id="message"
                      name="message"
                      class="form-control"
                      rows="6"
                      v-model="form.message"
                  ></textarea>
                </div>
                <div v-if="errors.message" style="color:red; font-size:0.9em;">
                  {{ errors.message }}
                </div>
                <div class="submit text-center">
                  <n-button
                      type="primary"
                      round
                      native-type="submit"
                  >
                    Nachricht schicken
                  </n-button>
                </div>
              </form>
              <div v-else class="text-center">
                <h3>Danke für Ihre Nachricht!</h3>
              </div>
            </div>
            <div class="col-md-5 ml-auto mr-auto">
              <info-section
                  type="primary"
                  icon="now-ui-icons tech_mobile"
              >
                <h4 class="info-title">
                  Rufen Sie uns an
                </h4>
                <p>
                  Thomas Boigner, MSc
                  <br><a href="tel:+4366475069874">+43 664 750 698 74</a>
                  <br>Mo. - Fr., 09:00-17:00
                </p>
              </info-section>
              <info-section
                  type="primary"
                  class="mt-5"
                  icon="now-ui-icons location_pin"
              >
                <h4 class="info-title">
                  oder kommen Sie in unser Büro
                </h4>
                <p>
                  <a href="https://www.google.com/maps/place/Elisenstra%C3%9Fe+27%2F1+1,+1230+Wien" target="_blank" @click.prevent="redirect">
                    Elisenstraße 27/1/1
                    <br />A-1230 Wien
                  </a>
                </p>
              </info-section>
              <info-section
                  type="primary"
                  icon="business_briefcase-24 now-ui-icons"
              >
                <h4 class="info-title">
                  Firmendaten
                </h4>
                <p>
                  <a href="https://www.boigner.digital" target="_blank">Boigner Digital GmbH</a>
                  <br /> Kaisersteig 4/2/3
                  <br />A-2380 Perchtoldsdorf
                </p>
              </info-section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gmap-map
        id="map"
        class="big-map"
        :center="center"
        :zoom="13"
        :options="options"
        map-type-id="terrain"
    >
      <gmap-marker :position="center" />
    </gmap-map>
  </div>
</template>

<script>
import { Button, InfoSection, FormGroupInput } from '@/components';
import { API_KEY } from '@/constants';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY
  }
});

export default {
  name: 'Contact',
  bodyClass: 'contact-page',
  components: {
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
      },
      errors: {
        firstName: '',
        lastName: '',
        emailPhone: '',
        message: ''
      },
      formSubmitted: false,
      formSubmitting: false,
      redirecting: false,
      center: {
        lat: 48.13288227419695,
        lng: 16.26648075587878
      },
      options: {},
      bgImage: require('@/assets/img/bg4.jpg')
    }
  },
  methods: {
    validateForm() {
      this.errors.emailPhone = '';
      this.errors.message = '';
      this.errors.firstName = '';
      this.errors.lastName = '';

      if (!this.form.firstName || this.form.firstName.trim().length < 2) {
        this.errors.firstName = 'Bitte geben Sie Ihren Vornamen ein.';
      }

      if (!this.form.lastName || this.form.lastName.trim().length < 2) {
        this.errors.lastName = 'Bitte geben Sie Ihren Nachnamen ein.';
      }

      if (!this.form.email.trim() && !this.form.phone.trim()) {
        this.errors.emailPhone = 'Bitte geben Sie entweder Ihre E-Mail-Adresse oder Telefonnummer an.';
      } else {
        if (this.form.email && !this.validateEmail(this.form.email)) {
          this.errors.emailPhone = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
        }
      }

      if (!this.form.message || this.form.message.trim().length < 4) {
        this.errors.message = 'Die Nachricht muss mindestens 4 Zeichen lang sein.';
      }

      return !this.errors.firstName && !this.errors.lastName && !this.errors.emailPhone && !this.errors.message;
    },

    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email.toLowerCase());
    },

    async handleSubmit() {
      const espoClient = this.useEspoClient();
      
      const interessent = {
        entityType: 'Lead',
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        emailAddress: this.form.email,
        phoneNumber: this.form.phone,
        description: this.form.message,
        source: 'Web Site'
      };

      try {
        this.formSubmitting = true;
        await espoClient.post('', interessent);

        this.formSubmitted = true;
        localStorage.removeItem('contactForm');
      } 
      catch (error) {
        console.error('Fehler beim Senden:', error);
      }
      finally {
        this.formSubmitting = false;
      }
    },

    onSubmit() {
      if (this.validateForm() && !this.formSubmitted && !this.formSubmitting) {
        this.handleSubmit();
      }
    },

    async redirect() {
        const espoClient = this.useEspoClient();

        try {
          this.redirecting = true;
          const response = await espoClient.get('redirect/mapselis');
          this.redirecting = false;
          
          if (response?.url) {
            window.open(response.url, '_blank');
          }
        } 
        catch {
          // Fail silently.
        }
        finally {
          this.redirecting = false;
        }
      }
  }
}
</script>

<style>
</style>
